import React from "react";

export default function GroupPinHeader(props) {
  const { columnGroup, columnApi, displayName } = props;

  const leaves   = columnGroup.getDisplayedLeafColumns();
  const isPinned = leaves.every(c => c.isPinned());

  const togglePin = () => {
    columnApi.applyColumnState({
      state : leaves.map(c => ({
        colId : c.getColId(),
        pinned: isPinned ? null : "left",
      })),
    });
  };

  return (
    <div className="ag-header-group-cell-label"  
         style={{ cursor: "pointer" }}
         onClick={togglePin}>
      <span className="ag-header-group-text">{displayName}</span>
      <span className="ag-icon ag-icon-pin" style={{ marginLeft: 4 }} />
    </div>
  );
}